import React from 'react';
import s from './SiteWide.styles';
const SiteWide = React.forwardRef((props, ref) => {
    const { children, className, isThin } = props;
    return (React.createElement(s.Container, { ref: ref, className: className, isThin: isThin }, children));
});
SiteWide.displayName = 'SiteWide';
export default SiteWide;
